import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { getAttrPreLoading: true, data: '', error: false };

export function attritionPredictorReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_ATTRITION_PREDICTOR:
            return {
                getAttrPreLoading: true,
                data: '',
                error: false
            };
        case AnalyzeConstants.RECEIVE_ATTRITION_PREDICTOR:
            return {
                getAttrPreLoading: false,
                data: action.res,
                error: false
            };
        case AnalyzeConstants.ERROR_ATTRITION_PREDICTOR:
            return {
                getAttrPreLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/attritionPredictor.reducer.js